export const FILTER_USER_REQUEST = " FILTER_USER_REQUEST";
export const FILTER_USER_SUCCESS = " FILTER_USER_SUCCESS";
export const FILTER_USER_FAILURE = " FILTER_USER_FAILURE";
